import { useIsMutating } from '@tanstack/react-query';
import { MUTATION_KEYS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { LuArchive, LuArchiveRestore } from 'react-icons/lu';

import { useArchiveChatMutation } from '~/features/whatsapp/hooks/useArchiveChatMutation';

type Props = {
    chatId: string;
    resolved: boolean;
    onSelect: () => void;
};

export const ArchiveChatMenuItem = ({ chatId, onSelect, resolved }: Props) => {
    const { t } = useTranslation();
    const { mutate } = useArchiveChatMutation(chatId);
    // Menu remounts on reopen — track pending across instances to block stale double clicks.
    const isPending = useIsMutating({ mutationKey: [MUTATION_KEYS.ARCHIVE_CHAT, chatId] }) > 0;
    const Icon = resolved ? LuArchiveRestore : LuArchive;

    return (
        <button
            type="button"
            disabled={isPending}
            className="flex w-full items-center gap-2 rounded px-3 py-2 text-left text-sm text-midnight hover:bg-surface-light disabled:cursor-not-allowed disabled:opacity-50"
            onClick={() => {
                onSelect();
                mutate({ archive: !resolved });
            }}
        >
            <Icon className="size-4 shrink-0" />
            {t(resolved ? 'WHATSAPP_CHAT.MENU.UNARCHIVE' : 'WHATSAPP_CHAT.MENU.ARCHIVE')}
        </button>
    );
};
